/**
 * @ngdoc service
 * @name CommonUtils.localStorage
 */
export default function ($window) {
    'ngInject';

    this.setItem = (key, value) => {
        $window.localStorage.setItem(key, JSON.stringify(value));
    };

    this.getItem = key => JSON.parse($window.localStorage.getItem(key));
}



// WEBPACK FOOTER //
// ./src/js/services/localStorageService.js